import React, { useState } from "react";
import { Table, Tag, Button, Space, Avatar, Tooltip } from "antd";
import { EyeOutlined, EditOutlined, DeleteOutlined } from "@ant-design/icons";
import { useNavigate } from "react-router-dom";

const ApplicationsPage = () => {
  const navigate = useNavigate();

  // Example static data (replace later with Firebase fetch)
  const [data] = useState([
    {
      key: "1",
      unit: "101",
      name: "Sarah M. Brooks",
      avatar: "https://i.pravatar.cc/40?img=1",
      date: "03/11/2025",
      amount: "73%",
      method: "",
      agent: "Christa Sardina",
      property: "3822 DT Amersfoort",
      status: "New",
    },
    {
      key: "3",
      unit: "101",
      name: "Robert V. Leavitt",
      avatar: "https://i.pravatar.cc/40?img=3",
      date: "01/20/2025",
      amount: "40%",
      method: "",
      agent: "Robert V. Leavitt",
      property: "Julianastraat ZX 7031",
      status: "Rejected",
    },
    {
      key: "2",
      unit: "341",
      name: "Joe K. Hall",
      avatar: "https://i.pravatar.cc/40?img=2",
      date: "06/18/2025",
      amount: "90%",
      method: "",
      agent: "Darren Rivera",
      property: "3181 BE Rozenburg",
      status: "Lease Sent",
    },
    {
      key: "4",
      unit: "795",
      name: "Lydia Anderson",
      avatar: "https://i.pravatar.cc/40?img=4",
      date: "02/09/2025",
      amount: "81%",
      method: "03/01/2025",
      agent: "Lydia Anderson",
      property: "2561 DB Den Haag",
      status: "Lease Signed",
    },
    {
      key: "5",
      unit: "472",
      name: "Jane Hanson",
      avatar: "https://i.pravatar.cc/40?img=5",
      date: "02/21/2024",
      amount: "77%",
      method: "03/15/2025",
      agent: "Lydia Anderson",
      property: "2561 DB Den Haag",
      status: "Tenant",
    },
    {
      key: "6",
      unit: "632",
      name: "Tim Pool",
      avatar: "https://i.pravatar.cc/40?img=6",
      date: "01/02/2024",
      amount: "85%",
      method: "02/01/2024",
      agent: "Lydia Anderson",
      property: "2561 DB Den Haag",
      status: "Tenant",
    },
  ]);

  const statusColors = {
    New: "purple",
    "Lease Sent": "green",
    "Lease Signed": "blue",
    Rejected: "red",
  };

  const columns = [
    {
      title: "Unit",
      dataIndex: "unit",
      key: "unit",
      render: (unit) => (
        <a onClick={() => navigate(`/landlord/listings/${unit}`)}>{unit}</a>
      ),
    },
    {
      title: "Applicant",
      dataIndex: "name",
      key: "name",
      render: (text, record) => (
        <Space>
          <Avatar src={record.avatar} />
          {text}
        </Space>
      ),
    },
    { title: "Received", dataIndex: "date", key: "date" },
    { title: "Move In", dataIndex: "method", key: "method" },
    { title: "Score", dataIndex: "amount", key: "amount" },
    // { title: "Agent Name", dataIndex: "agent", key: "agent" },
    // { title: "Invested Property", dataIndex: "property", key: "property" },
    {
      title: "Status",
      dataIndex: "status",
      key: "status",
      render: (status) => <Tag color={statusColors[status]}>{status}</Tag>,
    },
    {
      title: "Action",
      key: "action",
      render: (_, record) => (
        <Space>
          <Tooltip title="View Application">
            <Button
              shape="circle"
              icon={<EyeOutlined />}
              onClick={() => navigate(`/landlord/applications/${record.key}`)}
            />
          </Tooltip>
          <Tooltip title="Review/Send Lease">
            <Button shape="circle" icon={<EditOutlined />} />
          </Tooltip>
          <Tooltip title="Reject">
            <Button shape="circle" danger icon={<DeleteOutlined />} />
          </Tooltip>
        </Space>
      ),
    },
  ];

  return (
    <div style={{ padding: 24 }}>
      <Table columns={columns} dataSource={data} pagination={{ pageSize: 50 }} />
    </div>
  );
};

export default ApplicationsPage;